import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { Modal} from "react-bootstrap";

import locCsvFormat from '../images/locationsCsvFormat.png';

const LocationsCsvFormat = ({ isOpen, onRequestClose }) => {
  

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Location CSV Format</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
      <img src={locCsvFormat} alt="CSV Format" style={{ width: '100%' }} />
      </div>
      <br/>
      <h6>
        Follow this Format for Location CSV upload.
      </h6>

      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

export default LocationsCsvFormat;
